import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { asField } from 'informed';

import { ValidatorMessage } from 'helpers/validators';
import { CustomFormFieldProps } from './contracts';
import { getErrorTranslation } from './utils';
import { CheckboxBlock, CheckboxBlockProps } from './primitives/CheckboxBlock';

export const Checkbox = asField<
  Omit<CheckboxBlockProps, 'error' | 'id'> &
    CustomFormFieldProps & { customErrorText?: string },
  boolean
>(
  ({
    label,
    fieldApi,
    fieldState,
    translateError = true,
    checked,
    onClick,
    customErrorText,
    withColorBg,
    disabled,
    tooltip,
    width,
    height,
    ...props
  }) => {
    const { value, error } = fieldState;
    const { setValue } = fieldApi;

    const { t } = useTranslation();

    const id = (props as any).field;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      setValue(e.target.checked);
    };

    const errorText = useMemo(() => {
      if (error) {
        return customErrorText ? customErrorText : error;
      }
    }, [customErrorText, error]);

    const getError = useCallback(() => {
      if (error != null && translateError) {
        return getErrorTranslation(t, errorText as ValidatorMessage);
      }
      return error;
    }, [error, translateError, t, errorText]);

    return (
      <CheckboxBlock
        label={label}
        id={id}
        error={getError()}
        onChange={handleChange}
        onClick={onClick}
        checked={value}
        disabled={disabled}
        withColorBg={withColorBg}
        tooltip={tooltip}
        width={width}
        height={height}
      />
    );
  }
);
